/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/pinterest.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Pinterest',
  definitions: {
    '32': {
      viewBox: '0 0 33 32',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.1665 16.0001C30.1665 23.4748 24.1065 29.5348 16.6318 29.5348C15.2998 29.5348 14.0132 29.3401 12.7958 28.9801C13.3105 28.1668 13.8718 27.1241 14.1585 26.0801C14.3252 25.4788 15.1105 22.3601 15.1105 22.3601C15.5812 23.2575 16.9558 24.0468 18.4172 24.0468C22.7692 24.0468 25.7198 20.0801 25.7198 14.7708C25.7198 10.7575 22.3198 7.01745 17.1518 7.01745C10.7212 7.01745 7.4785 11.6281 7.4785 15.4721C7.4785 17.8001 8.3585 19.8708 10.2505 20.6428C10.5598 20.7695 10.8385 20.6481 10.9278 20.3041C10.9892 20.0668 11.1385 19.4681 11.2038 19.2188C11.2945 18.8788 11.2598 18.7601 11.0092 18.4641C10.4652 17.8201 10.1172 16.9881 10.1172 15.8095C10.1172 12.3895 12.6745 9.32812 16.7798 9.32812C20.4145 9.32812 22.4118 11.5481 22.4118 14.5148C22.4118 18.4175 20.6852 21.7108 18.1212 21.7108C16.7038 21.7108 15.6452 20.5388 15.9838 19.1041C16.3905 17.3895 17.1798 15.5375 17.1798 14.3001C17.1798 13.1935 16.5852 12.2681 15.3545 12.2681C13.9065 12.2681 12.7438 13.7668 12.7438 15.7721C12.7438 17.0495 13.1758 17.9135 13.1758 17.9135C13.1758 17.9135 11.6945 24.1895 11.4345 25.2895C11.1918 26.3175 11.1612 27.4521 11.1985 28.3961C6.4305 26.3028 3.09717 21.5428 3.09717 16.0001C3.09717 8.52412 9.15717 2.46545 16.6318 2.46545C24.1065 2.46545 30.1665 8.52412 30.1665 16.0001Z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
